export const numericAscending = (data, key) => {
  return data.sort((datum1, datum2) =>
    key ? datum1[key] - datum2[key] : datum1 - datum2,
  );
};
